const GENERIC_RE = /^(shape|icon|element|sticker|test|untitled|new)[\s_-]*\d*$/i;
const NUMERIC_RE = /^\d+$/;

export const isGenericName = (name) => {
  if (!name) return true;
  const trimmed = String(name).trim();
  if (!trimmed) return true;
  if (NUMERIC_RE.test(trimmed)) return true;
  if (GENERIC_RE.test(trimmed)) return true;
  return false;
};

export const displayNameOrEmpty = (name) => (isGenericName(name) ? '' : name);
